import axios from 'axios';
const API_URL = process.env.REACT_APP_API_URL;

export interface SecretaryData {
    civility: string;
    nom: string;
    prenom: string;
    email: string;
    rib: string;
    sharedPercentageReferral: number;
}

// Get secretary details for a given entreprise
export const getSecretary = async (entrepriseId: number) => {
    try {
        const response = await axios.get(`${API_URL}/entreprise/${entrepriseId}/secretary`);
        return response.data;
    } catch (error) {
        console.error('Error fetching secretary:', error);
        throw error;
    }
};

// Create a new secretary
export const createSecretary = async (data: SecretaryData & { entreprise_id: string }) => {
    try {
        const response = await axios.post(`${API_URL}/entreprise/${data.entreprise_id}/secretary`, {
            nom: data.nom,
            prenom: data.prenom,
            email: data.email,
            rib: data.rib,
            civility: data.civility,
            sharedPercentageReferral: data.sharedPercentageReferral
        });
        return response.data;
    } catch (error) {
        console.error('Error creating secretary:', error);
        throw error;
    }
};

// Delete the secretary from the entreprise team
export const deleteSecretary = async (entrepriseId: number, secretaryId: number) => {
    try {
        const response = await axios.delete(`${API_URL}/entreprise/${entrepriseId}/secretary/${secretaryId}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting secretary:', error);
        throw error;
    }
};

// Update shared percentage for secretary
export const updateSharedPercentage = async( secretaryId: number, sharedPercentageReferral: number ) => {
    try {
        const response = await axios.put(`${API_URL}/enterprise-team/${secretaryId}`, { sharedPercentageReferral });
        return response.data;
    } catch (error) {
        console.error('Error updating shared percentage:', error);
        throw error;
    }
};